import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { VendorRecoService } from 'src/app/services/misc/vendorreco/vendorreco.service';

@Component({
    selector: 'app-vendorrecodetail',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss']
})

export class VendorrecoDetailComponent implements OnInit, AfterViewInit {
    modelVendorRecoForm: FormGroup;
    @Input() public cell: any;
    isFormSubmitted = false;
    useEnterKey: any;

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private vendorRecoService: VendorRecoService,
        private _fb: FormBuilder,
        private utilities: Utilities,
    ) { }

    ngOnInit() {
        this.modelVendorRecoForm = this._fb.group({
            txtVendorAmount: [null],
            txtOtherAmountFS: [null],
            txtOtherAmountNoFS: [null],
            txtVendorOtherTotal: [null],
            txtWeight: [null],
            txtDeductAmount: [null],
            txtRemark: [null],
            txtClaim: [null],
        });
        this.getVendorRecoDetails();

        const userData = this.appCoreService.GetUserData();   
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.modelVendorRecoForm) : null;
    }

    getVendorRecoDetails() {
        try {
            // console.log("this.cell", this.cell);
            //this.ngxLoaderService.start();
            this.vendorRecoService.GetVendorRecoInfoById(this.cell).subscribe(res => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.modelVendorRecoForm.get('txtVendorAmount').setValue(res.data[0]?.vendoramount);
                    this.modelVendorRecoForm.get('txtOtherAmountFS').setValue(res.data[0]?.otheramountfuelsurcharge);
                    this.modelVendorRecoForm.get('txtOtherAmountNoFS').setValue(res.data[0]?.otheramountnofuelsurcharge);
                    this.modelVendorRecoForm.get('txtVendorOtherTotal').setValue(res.data[0]?.vendorothertotal);
                    this.modelVendorRecoForm.get('txtWeight').setValue(res.data[0]?.weight);
                    this.modelVendorRecoForm.get('txtDeductAmount').setValue(res.data[0]?.deductamount);
                    this.modelVendorRecoForm.get('txtRemark').setValue(res.data[0]?.remark);
                    this.modelVendorRecoForm.get('txtClaim').setValue(res.data[0]?.claim);
                }
            })
        } catch (err: any) {
            //this.ngxLoaderService.stop();
        }
    }

    updateVendorRecoDetails(): void {

        let reqObj = {
            id: this.cell,
            vendorAmount: this.modelVendorRecoForm.get('txtVendorAmount').value,
            otheramountfuelsurcharge: this.modelVendorRecoForm.get('txtOtherAmountFS').value,
            otheramountnofuelsurcharge: this.modelVendorRecoForm.get('txtOtherAmountNoFS').value,
            vendorOtherTotal: this.modelVendorRecoForm.get('txtVendorOtherTotal').value,
            weight: this.modelVendorRecoForm.get('txtWeight').value,
            deductAmount: this.modelVendorRecoForm.get('txtDeductAmount').value,
            remark: this.modelVendorRecoForm.get('txtRemark').value,
            claim: this.modelVendorRecoForm.get('txtClaim').value,
        }

        if (this.modelVendorRecoForm.valid) {            
            this.vendorRecoService.updateVendorRecoDetail(reqObj).subscribe(res => {
                if (res && res.success) {
                    this.appCoreService.showMessage('Detail Updated Successfully.', 'Success', 'success');
                    this.modelVendorRecoForm.reset();
                    this.activeModal.close('Save Click');
                }
            })
        }
    }

    reset(){
        this.modelVendorRecoForm.reset();
        this.activeModal.close('Cross click');
    }

}
